import { render, staticRenderFns } from "./FullPageGradientSpecialRate.vue?vue&type=template&id=ec0740d8&scoped=true"
import script from "./FullPageGradientSpecialRate.vue?vue&type=script&lang=js"
export * from "./FullPageGradientSpecialRate.vue?vue&type=script&lang=js"
import style0 from "./FullPageGradientSpecialRate.vue?vue&type=style&index=0&id=ec0740d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0740d8",
  null
  
)

export default component.exports